import { toQueryString } from 'shared/lib';

import {
  OnramperCryptoWallet,
  OnramperFiatId,
  OnramperId,
  OnramperMode,
  OnramperNetworkId,
  OnramperNetworkWallet,
} from '../types';

const ONRAMPER_BASE_URL_PROD = 'https://buy.onramper.com/';
const ONRAMPER_BASE_URL_DEV = 'https://buy.onramper.dev/';

const ONRAMPER_API_KEY = process.env.REACT_APP_ONRAMPER_API_KEY ?? 'pk_test_01J67VEXQZQMFQQ7BA89Y7722A';

if (!ONRAMPER_API_KEY) {
  throw new Error('No onramper api key provided');
}

export interface OnramperOptions {
  apiKey?: string;
  mode?: OnramperMode;
  themeName?: 'light' | 'dark';
  defaultFiat: OnramperFiatId;
  defaultCrypto?: OnramperId;
  onlyCryptos: OnramperId[];
  onlyCryptoNetworks: OnramperNetworkId[];
  wallets?: OnramperCryptoWallet[];
  networkWallets: OnramperNetworkWallet[];
  supportRecurringPayments: boolean;
  enableCountrySelector: boolean;
  supportSwap: boolean;
}

const arrayToParam = (array: OnramperId[] | OnramperNetworkId[]) => array.join(',');

const walletToParam = ({ wallet, ...rest }: OnramperCryptoWallet | OnramperNetworkWallet) =>
  'cryptoId' in rest ? `${rest.cryptoId}:${wallet}` : `${rest.networkId}:${wallet}`;

const walletsToParam = (wallets: OnramperCryptoWallet[] | OnramperNetworkWallet[]) =>
  arrayToParam(wallets.map(walletToParam));

export const buildOnramperUrl = ({
  wallets = [],
  apiKey = ONRAMPER_API_KEY,
  networkWallets = [],
  themeName = 'dark',
  ...params
}: Partial<OnramperOptions>) => {
  const baseUrl = apiKey.includes('pk_test_') ? ONRAMPER_BASE_URL_DEV : ONRAMPER_BASE_URL_PROD;

  const walletsParam = wallets.length > 0 ? `&wallets=${walletsToParam(wallets)}` : '';
  const networkWalletsParam = networkWallets.length > 0 ? `&networkWallets=${walletsToParam(networkWallets)}` : '';

  return `${baseUrl}?apiKey=${apiKey}&${toQueryString({
    ...params,
    themeName,
  })}${walletsParam}${networkWalletsParam}`;
};
